import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { horrorwritingfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            Hire Expert Horror Writers | Falcon Book Writing
        </title>
        <meta
          name="description"
          content="Hire expert horror writers with Falcon Book Writing to craft thrilling, spine-chilling stories and novels that captivate readers and leave a lasting impact."
        />
        <meta name="keywords" content="Expert Horror Writers" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg horrorwritingbg"
          title="Bring Terrifying Stories to Life With Expert"
          subtitle=" Horror Writing "
          title2=""
          para="Our expert horror writing turns dark ideas into heart-pounding stories, delivering shocking twists, chilling suspense, and unforgettable terror that keeps readers hooked from start to finish."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          title={`Professional  `}
          subtitle="  Horror Writing "
          title2="That Leaves Readers Breathless"
          description={`Horror is more than fear, it’s an experience that grips, shocks, and lingers long after the story ends. Our professional horror writing transforms your darkest ideas into fully realized narratives that keep readers on the edge of their seats. Every twist, every shadow, every chilling moment is meticulously crafted to evoke tension, dread, and suspense. From haunted settings and terrifying creatures to psychological thrills and shocking plot twists, we ensure every element is immersive and unforgettable. Characters come alive, fears feel real, and suspense builds page by page. The result is a story that doesn’t just scare - it enthralls, captivates, and haunts the imagination. Let your horror story leave readers breathless, eagerly turning pages and craving every twist of terror. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={horrorwritingfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
